import { File, FileImage, FileSpreadsheet, FileText, FileVideo } from "lucide-react";

export const IMAGE_EXT = ["png", "jpg", "jpeg", "webp", "gif", "svg", "bmp", "heic", "avif"];
export const VIDEO_EXT = ["mp4", "webm", "mov", "mkv", "avi", "m4v"];
export const OFFICE_EXT = ["doc", "docx", "xls", "xlsx", "ppt", "pptx"];

export const TYPE_META = {
  image: { label: "Ảnh", tone: "bg-sky-50 text-sky-700 ring-sky-200" },
  video: { label: "Video", tone: "bg-violet-50 text-violet-700 ring-violet-200" },
  doc: { label: "Tài liệu", tone: "bg-amber-50 text-amber-700 ring-amber-200" },
  other: { label: "Khác", tone: "bg-slate-100 text-slate-600 ring-slate-200" },
};

export const PROTECTED_ROOTS = new Set(["site/", "users/", "locations/"]);

export const extOf = (name) => {
  const base = String(name || "").split("?")[0].split("/").pop() || "";
  const i = base.lastIndexOf(".");
  return i < 0 ? "" : base.slice(i + 1).toLowerCase();
};

export const categoryOfExt = (ext) => {
  if (IMAGE_EXT.includes(ext)) return "image";
  if (VIDEO_EXT.includes(ext)) return "video";
  if (["pdf", "csv", "ods", "txt", "md", "json", "xml", ...OFFICE_EXT].includes(ext)) return "doc";
  return "other";
};

export const iconOfExt = (ext) => {
  if (IMAGE_EXT.includes(ext)) return FileImage;
  if (VIDEO_EXT.includes(ext)) return FileVideo;
  if (["xls", "xlsx", "csv", "ods"].includes(ext)) return FileSpreadsheet;
  if (["pdf", "doc", "docx", "txt", "md", "json", "xml"].includes(ext)) return FileText;
  return File;
};

export function fmtBytes(n) {
  const v = Number(n || 0);
  if (!Number.isFinite(v) || v <= 0) return "0 B";
  const units = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.min(units.length - 1, Math.floor(Math.log(v) / Math.log(1024)));
  return `${(v / 1024 ** i).toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

export function fmtDate(ts, withTime = false) {
  const d = ts ? new Date(ts) : null;
  if (!d || Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("vi-VN", withTime ? { dateStyle: "short", timeStyle: "short" } : { dateStyle: "medium" });
}

export function crumbsOf(prefix) {
  const out = [{ label: "Thư viện", prefix: "" }];
  let acc = "";
  for (const part of String(prefix || "").split("/").filter(Boolean)) {
    acc += `${part}/`;
    out.push({ label: part, prefix: acc });
  }
  return out;
}

export const sanitizeFileName = (name) =>
  String(name || "file").trim().replace(/[/\\]+/g, "-").replace(/\s+/g, " ").trim() || "file";

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      return ok;
    } catch {
      return false;
    }
  }
}
